import React from 'react';
import { shape, string } from 'prop-types';
import { Query } from 'react-apollo';
import Layout from 'components/layout';
import withApplicationConfig from 'containers/withApplicationConfig';
import ProviderResultsPage, {
  staticTextKeys as providerResultsPageStaticTextKeys,
} from 'pages/Verticals/ProviderResultsPage/ProviderResultsPage';
import {
  staticTextKeys as newsletterPanelStaticTextKeys,
} from 'components/staticPage/NewsLetter/NewsLetterPanel';
import Queries from 'queries';
import {
  getAuthQueryVariables, getStaticText, getImages,
} from 'helpers/Utils';

const ProviderResultsPageQuery = ({
  match: { params }, localisation, language, contentstackKeys,
}) => {
  const { vertical: list } = params;
  return (
    <Query
      query={Queries.GetProviderResultsPage}
      variables={{
        language: localisation[language],
        list: list?.toLowerCase(),
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: [
            ...providerResultsPageStaticTextKeys,
            ...newsletterPanelStaticTextKeys,
          ],
        }),
      }}
    >
      {({ loading, data, refetch }) => (
        <Layout
          {...data.pageConfig}
          seoMetadata={data.seoMetadata}
          componentConfig={data?.componentConfig}
          customerProfile={data?.customerProfile}
          staticText={getStaticText(data)}
          images={getImages(data)}
          refetch={refetch}
        >
          <ProviderResultsPage
            loading={loading}
            {...data.pageConfig}
            {...data.homePage}
            {...data.providerResultsPage}
            seoTable={data?.seoMetadata?.seoTable}
          />
        </Layout>
      )}
    </Query>
  );
};

ProviderResultsPageQuery.propTypes = {
  match: shape({}),
  localisation: shape({}),
  language: string.isRequired,
  contentstackKeys: shape({}).isRequired,
};

ProviderResultsPageQuery.defaultProps = {
  match: {},
  localisation: {},
};

export default withApplicationConfig(ProviderResultsPageQuery, ['languages', 'contentstackKeys']);
